import getRoleFromToken from "../../utils/getRoleFromToken";
import "./404.css";

import React from "react";

const Page404 = () => {
	return (
		<center
			className='center bg-white'
			style={{ height: "calc(100vh - 102px)" }}>
			<section className='page_404'>
				<div className='container'>
					<div className='row'>
						<div className='col-sm-12 '>
							<div className='col-sm-10 col-sm-offset-1  text-center'>
								<div className='four_zero_four_bg'>
									<h1 className='text-center '>404</h1>
								</div>
								<div className='contant_box_404'>
									<h3 className='h2'>Look like you're lost !</h3>

									<p>the page you are looking for not avaible!</p>

									<a
										href={ "admin/franchises" }
										className='link_404 btn-primary'>
										Go to Dashboard
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		</center>
	);
};

export default Page404;
